import "./style.scss";
import SectionHeader from "@components/SectionHeader";
import tools from "./img/tools.svg";
import SideBySideLayout from "../SideBySideLayout";
import BGMobile from "./img/header-mobile.jpg";
import BGDesktop from "./img/ic-maintenance-bg.jpg";

export default function MaintenanceBreak() {
  return (
    <SideBySideLayout
      position="center"
      bgImageDesktop={BGDesktop}
      bgImageMobile={BGMobile}
    >
      <div className="maintenance-break-content">
        <div className="hero-container">
          <div className="hero-wrapper">
            <div className="info-text">
              <SectionHeader>
                <strong>Entschuldigung</strong> für die Unannehmlichkeiten
              </SectionHeader>
            </div>
          </div>
        </div>
        <div className="main-content">
          <img className="info-icon" src={tools} alt="info-icon" />
          <p className="header">
            Wartungsarbeiten sind <br /> im Gange
          </p>
          <p className="sub-header">
            Wir verbessern den Inspiration Club gerade für dich.
            <br />
            <strong>Besuche uns in Kürze wieder.</strong>
          </p>
        </div>
      </div>
    </SideBySideLayout>
  );
}
